import { auth } from "services/firebase";
import { useAuthState } from "react-firebase-hooks/auth";

// Alter this function to return what is needed as we progress
export function useUser() {
    const [user, loading, error] = useAuthState(auth);
    return user;
}